<template>
	<ul class="nav nav--steps">
		<li v-for="step in totalSteps" :class="{ 'active' : step === currentStep }">
			<router-link :to="`${routeBase}/${step}`">{{ step }}</router-link>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
			currentStep: {
				type: Number,
				default: 1,
			},
			totalSteps: {
				type: Number,
				default: 1,
			},
			completedStep: {
				type: Number,
				default: 1,
			},
			routeBase: {
				type: String,
				default: '',
			}
		},
	}
</script>
